import { useEffect, useState } from 'react'
import SignIn from './pages/sign-in'
import Home from './pages/home'
import { useUserAuth } from './contexts/google-auth'

// E2E test bypass check - checks multiple sources for E2E mode flag
const checkE2ETestMode = (): boolean => {
  if (typeof window === 'undefined') return false

  // Check URL query parameter first (most reliable for Playwright)
  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get('e2e') === 'true') {
    // Set localStorage so subsequent navigation within the app works
    localStorage.setItem('E2E_TEST_MODE', 'true')
    return true
  }

  // Check localStorage (for internal navigation after initial load)
  if (localStorage.getItem('E2E_TEST_MODE') === 'true') {
    return true
  }

  return false
}

function App() {
  const { isLoading, user } = useUserAuth()
  const [isE2EMode, setIsE2EMode] = useState(false)

  // Check E2E mode on mount and whenever URL changes
  useEffect(() => {
    const checkMode = () => {
      const e2eMode = checkE2ETestMode()
      setIsE2EMode(e2eMode)
    }

    checkMode()

    // Re-check on popstate (browser back/forward)
    window.addEventListener('popstate', checkMode)
    return () => window.removeEventListener('popstate', checkMode)
  }, [])

  // Allow bypass for e2e tests
  const isAuthenticated = isE2EMode || (!isLoading && user)

  return <> {isAuthenticated ? <Home /> : <SignIn />} </>
}

export default App
